import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ['advancedFilters', 'newFilters', 'advancedFiltersToggleText', 'advancedFiltersNoResultsText', 'supplierAdvancedFiltersForm']
  static values = {
    resetAdvanced: Boolean
  }

  connect() {
    if (this.hasResetAdvancedValue && this.resetAdvancedValue) {
      this.switchToNewFilters()
    }
    this.setInitialState()
    this.toggleFilters()
    this.switchToNewFiltersWithLink()
  }

  getUrlParams() {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams;
  }

  setUrlParams(urlParams) {
    window.history.replaceState({}, '', '?' + urlParams.toString());
  }

  isAdvancedMode() {
    const urlParams = this.getUrlParams();
    return urlParams.get('advanced') === 'true' || localStorage.getItem("advanced_filters") === "true";
  }

  setInitialState() {
    if (this.isAdvancedMode()) {
      this.advancedFiltersTarget.classList.add('show');
      this.switchToAdvancedMode();
    } else {
      this.advancedFiltersTarget.querySelectorAll('.filter-container input, .filter-container select, .filter-container button')
        .forEach(el => {
          el.disabled = true
      });
    }
  }

  switchToNewFilters() {
    const filterGroup = this.advancedFiltersTarget.querySelector('.filter-group > ul');
    if (filterGroup) {
      filterGroup.innerHTML = '';
    }

    let urlParams = this.getUrlParams();
    urlParams.delete('advanced');
    this.setUrlParams(urlParams);
    this.advancedFiltersTarget.addEventListener('hidden.bs.collapse', () => {
      location.reload();
    }, { once: true });
    localStorage.setItem("advanced_filters", "false");
    const collapseInstance = bootstrap.Collapse.getInstance(this.advancedFiltersTarget) ||
                             new bootstrap.Collapse(this.advancedFiltersTarget, { toggle: false });
    collapseInstance.hide();
    if (this.hasAdvancedFiltersToggleTextTarget) {
      this.advancedFiltersToggleTextTarget.textContent = 'Show advanced filters';
    }
    if (this.hasAdvancedFiltersNoResultsTextTarget) {
      this.advancedFiltersNoResultsTextTarget.style.display = 'none';
    }
  }

  switchToAdvancedMode() {
    this.advancedFiltersTarget.querySelectorAll('.filter-container input, .filter-container select, .filter-container button').forEach(el => {
      el.disabled = false
    });
    if (this.hasNewFiltersTarget) {
      this.newFiltersTarget.querySelectorAll('input').forEach(el => {
        el.checked = false
      });
      this.newFiltersTarget.querySelectorAll('input, select, button').forEach(el => {
        el.disabled = true
      });
      this.newFiltersTarget.innerHTML = '<div></div>';
    }
    localStorage.setItem("advanced_filters", "true");
    let urlParams = this.getUrlParams();
    urlParams.set('advanced', 'true');
    this.setUrlParams(urlParams);
    this.advancedFiltersTarget.addEventListener('shown.bs.collapse', () => {
      location.reload();
    }, { once: true });
    
    if (this.hasAdvancedFiltersToggleTextTarget) {
      this.advancedFiltersToggleTextTarget.textContent = 'Hide advanced filters';
    }
    if (this.hasAdvancedFiltersNoResultsTextTarget) {
      this.advancedFiltersNoResultsTextTarget.style.display = 'block';
    }
  }

  toggleFilters() {
    let isAdvancedFiltersVisible = false;
    this.advancedFiltersTarget.addEventListener('show.bs.collapse', () => {
      isAdvancedFiltersVisible = true;
    });
    this.advancedFiltersTarget.addEventListener('hide.bs.collapse', () => {
      isAdvancedFiltersVisible = false;
    });
  
    document.querySelectorAll('.advanced-filters-toggle').forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (isAdvancedFiltersVisible) {
          this.switchToAdvancedMode();
        } else {
          this.switchToNewFilters();
        }
      });
    });
  }

  switchToNewFiltersWithLink() {
    $('#supplier-search').on('click', '.switch-to-new-filters', (e) => {
      e.preventDefault();
      this.switchToNewFilters();
    });
  }
}
